import { connect } from 'react-redux'

import { AppState } from '../reducers'
import Message from '../components/Message'

const mapStateToProps = (state: AppState) => ({
	message: state.message,
})

const ConnectedMessage = connect(mapStateToProps)(Message)

export type MessageProps = ReturnType<typeof mapStateToProps>

export default ConnectedMessage
